import TextInput from './textinput'
export default TextInput



/** WEBPACK FOOTER **
 ** ./es2015/controls/textinput/index.js
 **/